import List from './List/List';

const ListProviderUsluge = ({ data }) => {
  const columns = [
    { fieldname: 'nazivUsluge', label: 'Naziv usluge' },
    { fieldname: 'kolicina', label: 'Broj sati' },
    { fieldname: 'dobitZaposleniUsl', label: 'Iznos' },
  ];
  return (
    <div>
      <List
        listTitle="Usluge"
        titleName="imeZaposlenog"
        columns={columns}
        data={data}
      />
    </div>
  );
};

export default ListProviderUsluge;
